import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import store from '@/app/store'
import User from '@/users/entities/user'
import accountService from '@/users/services/account-service'
import authService from '@/users/services/auth-service'
import AccountModule from '@/users/store/account-module'
import { getModule } from 'vuex-module-decorators'
import AddressInput from '@/locations/components/address-input/address-input'
import snacks from '@/app/services/snacks'

@Component
export default class Settings extends Vue {
  @Ref()
  private validator!: ValidationObserver

  @Ref()
  private addressInput!: AddressInput

  private loading: boolean = false
  private sendingReset: boolean = false

  private data: User = new User()
  private originalData: User = new User()

  private async save() {
    if (await this.validator.validate()) {
      this.loading = true
      await this.addressInput.locateAsync()
      await accountService.updateCurrent(this.data)
      this.loading = false
      if (this.data.email !== this.originalData.email) {
        alert(
          'Ihre E-Mail-Adresse wurde geändert. Sie finden ein Bestätigungs-E-Mail in dem Posteingang Ihrer neuen E-Mail-Adresse. Bitte melden Sie sich anschließend erneut an.'
        )
        await authService.logoutAsync()
        this.$router.push({ name: 'home' })
      } else {
        snacks.success('Änderungen gespeichert.')
      }
    }
  }

  private async resetPassword() {
    const accountModule = getModule(AccountModule, store)
    this.loading = true
    await authService.sendPasswordResetLinkAsync(accountModule.userData.email)
    snacks.success(
      'Sie erhalten in Kürze eine E-Mail um Ihr Passwort zu ändern.'
    )
    this.loading = false
  }

  private async cancelUser() {
    if (
      confirm(
        'Wollen Sie Ihren Vertrag mit `Substituen finden` wirklich kündigen?'
      )
    ) {
      this.loading = true
      await accountService.cancelUser(this.data)
      snacks.success(
        'Ihre Kündigung wurde weitergeleitet und wird in Kürze bearbeitet.'
      )
      await authService.logoutAsync()
      this.$router.push({ name: 'home' })
      this.loading = false
    }
  }

  private mounted() {
    const accountModule = getModule(AccountModule, store)
    this.data = accountModule.userData
    this.originalData = JSON.parse(JSON.stringify(this.data))
  }
}
